var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-modal', {
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c('div', {
    staticClass: "capusta-info",
    attrs: {
      "slot": "content-wrapper"
    },
    slot: "content-wrapper"
  }, [_c('div', {
    staticClass: "capusta-info-close",
    on: {
      "click": _vm.handleClose
    }
  }), _c('div', {
    ref: "scrollContent",
    staticClass: "capusta-info-content"
  }, [_c('h4', {
    staticClass: "capusta-info-content-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('how.it.works.title')) + " ")]), _c('div', {
    staticClass: "capusta-info-content-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('how.it.works.message'))
    }
  }), _c('button', {
    staticClass: "capusta-info-done",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.ok')) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }